import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { FaMinimize, FaMaximize } from 'react-icons/fa6'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import { request } from '../../../_network/request'
import { serviceConfigsURLs, fileManagerURLs } from '../../../_network/apiUrls'
import { uiDomainInitial, uiCertificateInitial } from '../_common/userInterfaceConstants'
import { isWildcardMatch } from '../_helpers/rsaCertificates'
import { getFormattedDateTime, getIsoDateTime } from '../_helpers/dates'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'
import CustomBackdrop from '../../_common/CustomBackdrop'
import CustomDialog from '../../_common/CustomDialog'
import CustomerUiView from './CustomerUiView'
import CustomerUiEdit from './CustomerUiEdit'

const CustomerUiWrapper = (props) => {
  const { customerUiService, supportedServiceConfigs, setFetchServices } = props
  const theme = useTheme()

  const user_role = useSelector(state => state.profile.user_role)
  const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const [expanded, setExpanded] = useState(true)
  const [editMode, setEditMode] = useState(false)

  const [customerUiDomain, setCustomerUiDomain] = useState([{ ...uiDomainInitial }])
  const [customerUiCertificateJobs, setCustomerUiCertificateJobs] = useState([])
  const [customerUiCertificates, setCustomerUiCertificates] = useState([{ ...uiCertificateInitial }])
  const [customerUiSiteKey, setCustomerUiSiteKey] = useState('')
  const [customerUiSecretKey, setCustomerUiSecretKey] = useState('')
  const [defaultOpenStackDomain, setDefaultOpenStackDomain] = useState('')
  const [defaultOpenStackUserRole, setDefaultOpenStackUserRole] = useState('')
  const [signUpEnabled, setSignUpEnabled] = useState(true)
  const [isUsername, setIsUsername] = useState(false)
  const [usernamePriority, setUsernamePriority] = useState(10)
  const [isPassword, setIsPassword] = useState(false)
  const [passwordPriority, setPasswordPriority] = useState(20)
  const [isConfirmPassword, setIsConfirmPassword] = useState(false)
  const [confirmPasswordPriority, setConfirmPasswordPriority] = useState(30)
  const [isEmail, setIsEmail] = useState(false)
  const [emailPriority, setEmailPriority] = useState(40)
  const [isTermsOfUse, setIsTermsOfUse] = useState(false)
  const [termsOfUseText, setTermsOfUseText] = useState('')
  const [termsOfUseFile, setTermsOfUseFile] = useState(null)
  const [termsOfUseFileCurrent, setTermsOfUseFileCurrent] = useState(null)
  const [termsOfUseUrlPrefix, setTermsOfUseUrlPrefix] = useState('https://')
  const [termsOfUseUrl, setTermsOfUseUrl] = useState('')
  const [termsOfUseType, setTermsOfUseType] = useState('string')
  const [isPrivacyPolicy, setIsPrivacyPolicy] = useState(false)
  const [privacyPolicyText, setPrivacyPolicyText] = useState('')
  const [privacyPolicyFile, setPrivacyPolicyFile] = useState(null)
  const [privacyPolicyFileCurrent, setPrivacyPolicyFileCurrent] = useState(null)
  const [privacyPolicyUrlPrefix, setPrivacyPolicyUrlPrefix] = useState('https://')
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('')
  const [privacyPolicyType, setPrivacyPolicyType] = useState('string')
  const [customFields, setCustomFields] = useState([])
  const [customerUiLogo, setCustomerUiLogo] = useState(null)
  const [customerUiCurrentLogo, setCustomerUiCurrentLogo] = useState(null)
  const [customerUiPrimaryColor, setCustomerUiPrimaryColor] = useState(theme.palette.brilliantAzure)
  const [customerUiSecondaryColor, setCustomerUiSecondaryColor] = useState(theme.palette.darkCyan)
  const [backgroundType, setBackgroundType] = useState('')
  const [colorType, setColorType] = useState('')
  const [backgroundColor, setBackgroundColor] = useState(theme.palette.darkCyan)
  const [gradientColor1, setGradientColor1] = useState(theme.palette.darkCyan)
  const [gradientColor2, setGradientColor2] = useState(theme.palette.darkCyan)
  const [backgroundImage, setBackgroundImage] = useState(null)
  const [backgroundImageCurrent, setBackgroundImageCurrent] = useState(null)
  const [headingText, setHeadingText] = useState('')
  const [promoText1, setPromoText1] = useState('')
  const [promoText2, setPromoText2] = useState('')
  const [promoText3, setPromoText3] = useState('')
  const [isContact, setIsContact] = useState(true)
  const [contactCompany, setContactCompany] = useState('')
  const [contactPhone, setContactPhone] = useState([''])
  const [contactEmail, setContactEmail] = useState([''])

  const [domainsWithCertififcates, setDomainsWithCertificates] = useState([])
  const [certificateAction, setCertificateAction] = useState('')
  const [errors, setErrors] = useState([])
  const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const wrapperStyle = {
    background: 'white',
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)',
    marginBottom: '40px',
  }

  const headStyle = {
    width: '100%',
    height: '60px',
  }

  const bodyStyle = {
    padding: '20px',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 40px',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const editButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.vodka,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',
    marginTop: '20px',

    '&:hover': {
      background: alpha(theme.palette.vodka, 0.8),
    },
  }

  const saveButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',
    marginTop: '20px',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const removeSpacesAndSpecialChars = (str) => {
    return str.replace(/[\s~`!@#$%^&*(){}[\];:"'<,>?/\\|+=-]/g, '')
  }

  const handleErrorDialogOpen = () => {
    setErrorDialogOpen(true)
  }

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false)
  }

  const getSelectFieldList = useCallback((service, field, sub_field) => {
    let result = []
    let options_list = []

    const service_object = supportedServiceConfigs.find(item => item.service === service)

    if (sub_field && service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field][sub_field] && service_object.config_params[field][sub_field].length > 0) {
      options_list = service_object.config_params[field][sub_field]
    } else if (service_object && service_object.config_params && service_object.config_params[field] && service_object.config_params[field].length > 0) {
      options_list = service_object.config_params[field]
    }

    options_list.forEach(item => {
      result.push({
        keyword: capitalizeFirstLetter(item),
        value: item,
      })
    })

    return result
  }, [supportedServiceConfigs])

  const getDomainListFromCertificate = (service_domains, certificate_domain) => {
    let result = []

    service_domains.forEach(d => {
      const is_wildcard_match = isWildcardMatch(certificate_domain, d)
      if (is_wildcard_match && !result.includes(d)) {
        result.push(d)
      }
    })

    return result
  }

  const getDomainListFromJobId = (job_id) => {
    let result = []
    const filtered_jobs = customerUiCertificateJobs.filter(item => item.job_id === job_id)

    filtered_jobs.forEach(item => {
      result.push(item.domain)
    })

    return result
  }

  const deleteFileRequest = async (file_url) => {
    const url = constants.core_service_domain + '/' + fileManagerURLs.getDeleteFile
    const form_data = new FormData()
    form_data.append('file_url', file_url)
    const request_data = { url, method: 'DELETE', form_data }
    await request(request_data)
  }

  const verifyDomain = async ({ showLoading }) => {
    if (showLoading) {
      setIsLoading(true)
    }
    
    let result = true
    let updated_domains = []

    for (let index = 0; index < customerUiDomain.length; index++) {
      const d = customerUiDomain[index]
      let new_status = ''

      if (!d.domain_name) {
        result = false
      }

      if (d.domain_name && d.status !== 'verified') {
        const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceDnsResolver

        const postData = {
          domain_name: d.domain_name,
          subdomain_prefix: d.subdomain_prefix,
          type: 'client',
        }

        const request_data = { url, method: 'POST', data: postData }    

        const response = await request(request_data)
        
        if (response && response.status_code < 400) {
          new_status = 'verified'
        } else {
          new_status = 'not verified'
          result = false

          if (response && response.error) {
            const error = JSON.parse(response.error)
            if (error && error.detail) {
              new_status = error.detail
            }
          }
        }

        updated_domains.push({ ...d, status: new_status })
      } else {
        updated_domains.push(d)
      }
    }

    if (showLoading) {
      setIsLoading(false)
    }
    
    setCustomerUiDomain(updated_domains)
    
    return {
      result,
      domains: updated_domains,
    }
  }

  const validateCustomerFrontendForm = () => {
    let errors_list = []

    customerUiDomain.forEach((item, index) => {
      const domain = item.subdomain_prefix ? item.subdomain_prefix + '.' + item.domain_name : item.domain_name

      if (!domain) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.userInterfaceDomain,
          field_key: 'customer-domain_name-' + index,
        })
      } else if (!domainsWithCertififcates.includes(domain)) {
        errors_list.push({
          title: defaultTexts.noValidCertificateForDomain + ' - ' + domain,
        })
      }
    })

    if (!customerUiSiteKey) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.siteKey,
        field_key: 'customerUiSiteKey',
      })
    }

    if (!customerUiSecretKey) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.secretKey,
        field_key: 'customerUiSecretKey',
      })
    }

    if (customerUiLogo) {
      if (customerUiLogo.type && customerUiLogo.type !== 'image/png' && customerUiLogo.type !== 'image/jpeg') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.uploadLogosFile,
        })
      }
    }

    if (!defaultOpenStackDomain) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.defaultOpenStackDomain,
        field_key: 'defaultOpenStackDomain',
      })
    }

    if (!defaultOpenStackUserRole) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.defaultOpenStackUserRole,
        field_key: 'defaultOpenStackUserRole',
      })
    }

    if (isUsername && !usernamePriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.username + ' ' + defaultTexts.priority,
        field_key: 'usernamePriority',
      })
    }

    if (isPassword && !passwordPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.password + ' ' + defaultTexts.priority,
        field_key: 'passwordPriority',
      })
    }

    if (isConfirmPassword && !confirmPasswordPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.confirmPassword + ' ' + defaultTexts.priority,
        field_key: 'confirmPasswordPriority',
      })
    }

    if (isEmail && !emailPriority) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.email + ' ' + defaultTexts.priority,
        field_key: 'emailPriority',
      })
    }

    if (isTermsOfUse && termsOfUseType === 'text' && !termsOfUseText) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        field_key: 'termsOfUseText',
      })
    }

    if (isTermsOfUse && termsOfUseType === 'file' && !termsOfUseFile) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
      })
    }

    if (isTermsOfUse && termsOfUseType === 'file' && termsOfUseFile) {
      if (termsOfUseFile.type && termsOfUseFile.type !== 'application/pdf') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        })
      }
    }

    if (isTermsOfUse && termsOfUseType === 'url' && !termsOfUseUrl) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.termsOfUse,
        field_key: 'termsOfUseUrl',
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'text' && !privacyPolicyText) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        field_key: 'privacyPolicyText',
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'file' && !privacyPolicyFile) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
      })
    }

    if (isPrivacyPolicy && privacyPolicyType === 'file' && privacyPolicyFile) {
      if (privacyPolicyFile.type && privacyPolicyFile.type !== 'application/pdf') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        })
      }
    }

    if (isPrivacyPolicy && privacyPolicyType === 'url' && !privacyPolicyUrl) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.privacyPolicy,
        field_key: 'privacyPolicyUrl',
      })
    }

    customFields.forEach((item, index) => {
      if (!item.field_key) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.fieldKey + ' ' + (index + 1),
          field_key: 'custom-fields-field_key-' + index,
        })
      }

      if (!item.label) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.label + ' ' + (index + 1),
          field_key: 'custom-fields-label-' + index,
        })
      }

      if (!item.priority) {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.customFields + ' - ' + defaultTexts.priority + ' ' + (index + 1),
          field_key: 'custom-fields-priority-' + index,
        })
      }
    })

    if (!backgroundType) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundType,
        field_key: 'backgroundType',
      })
    }

    if (backgroundType === 'color' && !colorType) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.colorType,
        field_key: 'colorType',
      })
    }

    if (backgroundType === 'color' && colorType === 'solid' && !backgroundColor) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundColor,
        field_key: 'backgroundColor',
      })
    }

    if (backgroundType === 'color' && colorType === 'gradient' && !gradientColor1) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.gradientColor + ' 1',
        field_key: 'gradientColor1',
      })
    }

    if (backgroundType === 'color' && colorType === 'gradient' && !gradientColor2) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.gradientColor + ' 2',
        field_key: 'gradientColor2',
      })
    }

    if (backgroundType === 'image' && !backgroundImage) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundImage,
        field_key: 'backgroundImage',
      })
    }

    if (backgroundType === 'image' && backgroundImage) {
      if (backgroundImage.type && backgroundImage.type !== 'image/png' && backgroundImage.type !== 'image/jpeg') {
        errors_list.push({
          title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.backgroundImage,
          field_key: 'backgroundImage',
        })
      }
    }

    if (isContact && !contactCompany) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.company,
        field_key: 'contactCompany',
      })
    }

    if (isContact && contactPhone.length > 0 && !contactPhone[0]) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.phone,
        field_key: 'contactPhone',
      })
    }

    if (isContact && contactEmail.length > 0 && !contactEmail[0]) {
      errors_list.push({
        title: defaultTexts.openStackCustomerUi + ' - ' + defaultTexts.email,
        field_key: 'contactEmail',
      })
    }

    return errors_list
  }

  const validateFormFields = () => {
    let errors_list = []

    const frontend_customer_form_errors = validateCustomerFrontendForm()
    errors_list = [...errors_list, ...frontend_customer_form_errors]

    setErrors(errors_list)
    
    return errors_list.length === 0 ? true : false
  }

  const validateForm = async () => {
    const form_fields_valid = validateFormFields()
    let customer_domains_verified = { result: false, domains: customerUiDomain }

    if (form_fields_valid) {
      customer_domains_verified = await verifyDomain({ showLoading: false })
    }
 
    if (form_fields_valid && !customer_domains_verified.result) {
      setErrors(prev => [...prev, { title: defaultTexts.customerUiDomain + ' ' + defaultTexts.notVerified }])
    }

    const result = (form_fields_valid && customer_domains_verified.result)

    return {
      result,
      customer_ui_domains: customer_domains_verified.domains,
    }
  }

  const handleClickEdit = () => {
    setEditMode(true)
  }

  const uploadFileRequest = async (file_to_upload, url_key) => {
    const url = constants.core_service_domain + '/' + fileManagerURLs[url_key]

    const form_data = new FormData()
    form_data.append('file', file_to_upload, removeSpacesAndSpecialChars(file_to_upload.name))

    const request_data = { url, method: 'POST', form_data }

    const response = await request(request_data)

    if (response && response.status_code && response.status_code < 400 && response.data && response.data.url) {
      return response.data.url
    }
  }

  const clientServiceConfigsRequest = async (postData) => {
    const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceConfigs + '/' + customerUiService.id
    const request_data = { url, method: 'PUT', data: postData }
    await request(request_data)
  }

  const clientCertificateConfigsRequest = async ({ method, data, record_id }) => {
    const url = record_id ?
    constants.core_service_domain + '/' + serviceConfigsURLs.getClientCertificateConfigs + '/' + record_id :
    constants.core_service_domain + '/' + serviceConfigsURLs.getClientCertificateConfigs

    const request_data = data ? { url, method, data } : { url, method }

    const response = await request(request_data)

    console.log('client-certificate-configs', request_data, response)
  }

  const handleCertificatesUpdate = async (service_domains) => {
    if (certificateAction === 'generate') {
      for (let index = 0; index < customerUiCertificateJobs.length; index++) {
        const j = customerUiCertificateJobs[index]
        await clientCertificateConfigsRequest({ method: 'DELETE', record_id: j.job_id })
      }

      const postData = {
        ui_type: 'client',
        generate_certificate: true,
        domains: service_domains,
      }

      await clientCertificateConfigsRequest({ method: 'POST', data: postData })
    } else if (certificateAction === 'upload') {
      let updated_job_ids = []
      let certificates_to_create = []

      for (let index = 0; index < customerUiCertificates.length; index++) {
        const c = customerUiCertificates[index]
        const certificate_domains = getDomainListFromCertificate(service_domains, c.domain)
        
        for (let index = 0; index < customerUiCertificateJobs.length; index++) {
          const j = customerUiCertificateJobs[index]
          const job_domains = getDomainListFromJobId(j.job_id)

          if (JSON.stringify(certificate_domains) === JSON.stringify(job_domains)) {
            const postData = {
              certificate: {
                domains: certificate_domains,
                expiration_date: getIsoDateTime(c.expire_date),
                certificate: c.certificate,
                private_key: c.private_key,
                chain: c.full_chain,
              }
            }

            await clientCertificateConfigsRequest({ method: 'PUT', data: postData, record_id: j.job_id })

            updated_job_ids.push(j.job_id)
          } else {
            certificates_to_create.push({
              domains: certificate_domains,
              expiration_date: getIsoDateTime(c.expire_date),
              certificate: c.certificate,
              private_key: c.private_key,
              chain: c.full_chain,
            })
          }
        }
      }

      if (certificates_to_create.length > 0) {
        const postData = {
          ui_type: 'client',
          generate_certificate: false,
          certificates: certificates_to_create,
        }
  
        await clientCertificateConfigsRequest({ method: 'POST', data: postData })
      }      

      for (let index = 0; index < customerUiCertificateJobs.length; index++) {
        const j = customerUiCertificateJobs[index]

        if (!updated_job_ids.includes(j.job_id)) {
          await clientCertificateConfigsRequest({ method: 'DELETE', record_id: j.job_id })
        }        
      }
    }

    setCertificateAction('')    
  }

  const handleClickSave = async () => {
    setIsLoading(true)

    const form_valid = await validateForm() 

    if (form_valid.result) {
      let logo_url = ''

      if (customerUiLogo && typeof customerUiLogo !== 'string') {
        const logo_filename = await uploadFileRequest(customerUiLogo, 'getUploadUiLogo')
        if (logo_filename) {
          logo_url = logo_filename
        }
        if (customerUiCurrentLogo) {
          await deleteFileRequest(customerUiCurrentLogo)
        }
      } else if (customerUiLogo) {
        logo_url = customerUiLogo
      }

      let customer_ui_domains = []

      form_valid.customer_ui_domains.forEach(item => {
        customer_ui_domains.push(item.subdomain_prefix ? item.subdomain_prefix + '.' + item.domain_name : item.domain_name)
      })

      let promo_text = []
      let form_fields = []
      let documents = []
      let priority_values = []

      if (promoText1) {
        promo_text.push(promoText1)
      }

      if (promoText2) {
        promo_text.push(promoText2)
      }

      if (promoText3) {
        promo_text.push(promoText3)
      }

      if (isUsername) {
        form_fields.push({
          priority: usernamePriority,
          field_key: 'username',
          openstack_field: 'name',
          label: 'Username',
          field_type: 'string',
          required: true,
          content_type: null,
        })
        priority_values.push(usernamePriority)
      }

      if (isPassword) {
        form_fields.push({
          priority: passwordPriority,
          field_key: 'password',
          openstack_field: 'password',
          label: 'Password',
          field_type: 'string',
          required: true,
          content_type: 'password',
        })
        priority_values.push(passwordPriority)
      }

      if (isConfirmPassword) {
        form_fields.push({
          priority: confirmPasswordPriority,
          field_key: 'confirm_password',
          openstack_field: null,
          label: 'Confirm password',
          field_type: 'string',
          required: true,
          content_type: 'password',
        })
        priority_values.push(confirmPasswordPriority)
      }

      if (isEmail) {
        form_fields.push({
          priority: emailPriority,
          field_key: 'email',
          openstack_field: 'email',
          label: 'E-mail',
          field_type: 'string',
          required: true,
          content_type: 'email',
        })
        priority_values.push(emailPriority)
      }

      customFields.forEach(item => {
        form_fields.push({
          priority: item.priority,
          field_key: item.field_key,
          openstack_field: item.field_key,
          label: item.label,
          field_type: 'string',
          required: item.required,
          content_type: null,
        })
        priority_values.push(item.priority)
      })

      const maxPriortiy = Math.max(...priority_values)

      if (isTermsOfUse) {
        form_fields.push({
          priority: maxPriortiy + 10,
          field_key: 'tou',
          openstack_field: 'tou',
          label: 'Terms of Use',
          field_type: 'boolean',
          required: true,
          content_type: null,
        })

        let terms_of_use_file = termsOfUseType === 'file' ? termsOfUseFile : termsOfUseUrlPrefix + termsOfUseUrl

        if (typeof terms_of_use_file !== 'string') {
          const terms_of_use_filename = await uploadFileRequest(terms_of_use_file, 'getUploadUiDoc')
          if (terms_of_use_filename) {
            terms_of_use_file = terms_of_use_filename
          }
        }

        if (termsOfUseFileCurrent && (termsOfUseType !== 'file' || typeof terms_of_use_file !== 'string')) {
          await deleteFileRequest(termsOfUseFileCurrent)
        }

        documents.push({
          label: 'Terms of Use',
          type: termsOfUseType,
          value: termsOfUseType === 'string' ? termsOfUseText : terms_of_use_file,
        })
      }

      if (isPrivacyPolicy) {
        form_fields.push({
          priority: maxPriortiy + 20,
          field_key: 'pp',
          openstack_field: 'pp',
          label: 'Privacy Policy',
          field_type: 'boolean',
          required: true,
          content_type: null,
        })

        let privacy_policy_file = privacyPolicyType === 'file' ? privacyPolicyFile : privacyPolicyUrlPrefix + privacyPolicyUrl

        if (typeof privacy_policy_file !== 'string') {
          const privacy_policy_filename = await uploadFileRequest(privacy_policy_file, 'getUploadUiDoc')
          if (privacy_policy_filename) {
            privacy_policy_file = privacy_policy_filename
          }
        }

        if (privacyPolicyFileCurrent && (privacyPolicyType !== 'file' || typeof privacy_policy_file !== 'string')) {
          await deleteFileRequest(privacyPolicyFileCurrent)
        }

        documents.push({
          label: 'Privacy Policy',
          type: privacyPolicyType,
          value: privacyPolicyType === 'string' ? privacyPolicyText : privacy_policy_file,
        })
      }

      let background_image_url = ''

      if (backgroundImage && typeof backgroundImage !== 'string') {
        const background_image_filename = await uploadFileRequest(backgroundImage, 'getUploadUiBg')
        if (background_image_filename) {
          background_image_url = background_image_filename
        }
        if (backgroundImageCurrent) {
          await deleteFileRequest(backgroundImageCurrent)
        }
      } else if (backgroundImage) {
        background_image_url = backgroundImage
      }

      const postData = {
        config_params: {
          service_domain: customer_ui_domains,
          primary_color: customerUiPrimaryColor,
          secondary_color: customerUiSecondaryColor,
          logo: logo_url,
          openstack_domain: defaultOpenStackDomain,
          openstack_role: defaultOpenStackUserRole,
          contact_us: isContact ? {
            phone: contactPhone,
            email: contactEmail,
            company: contactCompany,
          } : null,
          promo_config: {
            background_type: backgroundType,
            background_color_type: colorType,
            background_color: backgroundColor,
            gradient_color_1: gradientColor1,
            gradient_color_2: gradientColor2,
            background_image: background_image_url,
            heading: headingText,
            promo_text,
          },
          captcha_config: {
            site_key: customerUiSiteKey,
            secret_key: customerUiSecretKey,
          },          
          signup_config: {
            enabled: signUpEnabled,
            form_fields,
            documents,
          },
        },
      }
      
      await clientServiceConfigsRequest(postData)

      await handleCertificatesUpdate(customer_ui_domains)

      setFetchServices(prev => prev + 1)
      setEditMode(false)
    } else {
      handleErrorDialogOpen()
    }

    setIsLoading(false) 
  }

  useEffect(() => {
    const verifySingleDomain = async (subdomain_prefix, domain_name) => {
      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceDnsResolver

      const postData = {
        domain_name,
        subdomain_prefix,
        type: 'client',
      }

      const request_data = { url, method: 'POST', data: postData }    

      const response = await request(request_data)
      
      if (response && response.status_code < 400) {
        return 'verified'
      } else {
        return 'not verified'
      }
    }

    const fetchFullData = async () => {
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.service_domain) {
        let domains = []
  
        for (let index = 0; index < customerUiService.config_params.service_domain.length; index++) {
          const item = customerUiService.config_params.service_domain[index]
          
          const domain_parts = item.split('.')
          const subdomain_prefix = domain_parts.slice(0, -2).join('.')
          const domain_name = domain_parts.slice(-2).join('.')
          const status = await verifySingleDomain(subdomain_prefix, domain_name)
          
          domains.push({
            subdomain_prefix,
            domain_name,
            status,
          })
        }
  
        setCustomerUiDomain(domains)
      } else {
        setCustomerUiDomain([{ ...uiDomainInitial }])
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.primary_color) {
        setCustomerUiPrimaryColor(customerUiService.config_params.primary_color)
      } else {
        setCustomerUiPrimaryColor(theme.palette.oriolesOrange)
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.secondary_color) {
        setCustomerUiSecondaryColor(customerUiService.config_params.secondary_color)
      } else {
        setCustomerUiSecondaryColor(theme.palette.mayGreen)
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.captcha_config && customerUiService.config_params.captcha_config.site_key) {
        setCustomerUiSiteKey(customerUiService.config_params.captcha_config.site_key)
      } else {
        setCustomerUiSiteKey('')
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.captcha_config && customerUiService.config_params.captcha_config.secret_key) {
        setCustomerUiSecretKey(customerUiService.config_params.captcha_config.secret_key)
      } else {
        setCustomerUiSecretKey('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.openstack_domain) {
        setDefaultOpenStackDomain(customerUiService.config_params.openstack_domain)
      } else {
        setDefaultOpenStackDomain('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.openstack_role) {
        setDefaultOpenStackUserRole(customerUiService.config_params.openstack_role)
      } else {
        setDefaultOpenStackUserRole('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.signup_config) {
        setSignUpEnabled(customerUiService.config_params.signup_config.enabled ? true : false)
      } else {
        setSignUpEnabled(true)
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.contact_us) {
        setIsContact(true)
      } else {
        setIsContact(false)
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.contact_us && customerUiService.config_params.contact_us.company) {
        setContactCompany(customerUiService.config_params.contact_us.company)
      } else {
        setContactCompany('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.contact_us && customerUiService.config_params.contact_us.phone) {
        setContactPhone(customerUiService.config_params.contact_us.phone)
      } else {
        setContactPhone([''])
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.contact_us && customerUiService.config_params.contact_us.email) {
        setContactEmail(customerUiService.config_params.contact_us.email)
      } else {
        setContactEmail([''])
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.background_type) {
        setBackgroundType(customerUiService.config_params.promo_config.background_type)
      } else {
        setBackgroundType('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.background_color_type) {
        setColorType(customerUiService.config_params.promo_config.background_color_type)
      } else {
        setColorType('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.background_color) {
        setBackgroundColor(customerUiService.config_params.promo_config.background_color)
      } else {
        setBackgroundColor(theme.palette.darkCyan)
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.gradient_color_1) {
        setGradientColor1(customerUiService.config_params.promo_config.gradient_color_1)
      } else {
        setGradientColor1(theme.palette.darkCyan)
      }
  
      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.gradient_color_2) {
        setGradientColor2(customerUiService.config_params.promo_config.gradient_color_2)
      } else {
        setGradientColor2(theme.palette.darkCyan)
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.background_image) {
        setBackgroundImage(customerUiService.config_params.promo_config.background_image)
        setBackgroundImageCurrent(customerUiService.config_params.promo_config.background_image)
      } else {
        setBackgroundImage(null)
        setBackgroundImageCurrent(null)
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.heading) {
        setHeadingText(customerUiService.config_params.promo_config.heading)
      } else {
        setHeadingText('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.promo_config && customerUiService.config_params.promo_config.promo_text) {
        if (customerUiService.config_params.promo_config.promo_text.length > 0) {
          setPromoText1(customerUiService.config_params.promo_config.promo_text[0])
        } else {
          setPromoText1('')
        }
  
        if (customerUiService.config_params.promo_config.promo_text.length > 1) {
          setPromoText2(customerUiService.config_params.promo_config.promo_text[1])
        } else {
          setPromoText2('')
        }
  
        if (customerUiService.config_params.promo_config.promo_text.length > 2) {
          setPromoText3(customerUiService.config_params.promo_config.promo_text[2])
        } else {
          setPromoText3('')
        }
      } else {
        setPromoText1('')
        setPromoText2('')
        setPromoText3('')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.signup_config && customerUiService.config_params.signup_config.form_fields && customerUiService.config_params.signup_config.form_fields.length > 0) {
        let custom_fields = []
  
        customerUiService.config_params.signup_config.form_fields.forEach(item => {
          if (item.field_key === 'username') {
            setIsUsername(true)
            setUsernamePriority(item.priority)
          } else if (item.field_key === 'password') {
            setIsPassword(true)
            setPasswordPriority(item.priority)
          } else if (item.field_key === 'confirm_password') {
            setIsConfirmPassword(true)
            setConfirmPasswordPriority(item.priority)
          } else if (item.field_key === 'email') {
            setIsEmail(true)
            setEmailPriority(item.priority)
          } else if (item.field_key !== 'tou' && item.field_key !== 'pp') {
            custom_fields.push({
              field_key: item.field_key,
              label: item.label,
              priority: item.priority,
              required: item.required,
            })
          }
        })
  
        setCustomFields(custom_fields)
      } else {
        setIsUsername(true)
        setUsernamePriority(10)
        setIsPassword(true)
        setPasswordPriority(20)
        setIsConfirmPassword(true)
        setConfirmPasswordPriority(30)
        setIsEmail(true)
        setEmailPriority(40)
        setCustomFields([])
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.signup_config && customerUiService.config_params.signup_config.documents && customerUiService.config_params.signup_config.documents.length > 0) {
        customerUiService.config_params.signup_config.documents.forEach(item => {
          if (item.label === 'Terms of Use') {
            setIsTermsOfUse(true)
            setTermsOfUseText(item.type === 'string' ? item.value : '')
  
            let url_prefix = 'https://'
            let url_cut = ''
  
            if (item.type === 'url') {
              let url_list = item.value.split('//')
              if (url_list.length > 1) {
                url_prefix = url_list[0] + '//'
                url_cut = url_list[1]
              }
            }

            if (item.type === 'file') {
              setTermsOfUseFile(item.value)
              setTermsOfUseFileCurrent(item.value)
            } else {
              setTermsOfUseFile(null)
              setTermsOfUseFileCurrent(null)
            }
            
            setTermsOfUseType(item.type)
            setTermsOfUseUrlPrefix(url_prefix)
            setTermsOfUseUrl(url_cut)
          }
  
          if (item.label === 'Privacy Policy') {
            setIsPrivacyPolicy(true)
            setPrivacyPolicyText(item.type === 'string' ? item.value : '')
  
            let url_prefix = 'https://'
            let url_cut = ''
  
            if (item.type === 'url') {
              let url_list = item.value.split('//')
              if (url_list.length > 1) {
                url_prefix = url_list[0] + '//'
                url_cut = url_list[1]
              }
            }

            if (item.type === 'file') {
              setPrivacyPolicyFile(item.value)
              setPrivacyPolicyFileCurrent(item.value)
            } else {
              setPrivacyPolicyFile(null)
              setPrivacyPolicyFileCurrent(null)
            }
            
            setPrivacyPolicyType(item.type)
            setPrivacyPolicyUrlPrefix(url_prefix)
            setPrivacyPolicyUrl(url_cut)
          }
        })
      } else {
        setIsTermsOfUse(false)
        setTermsOfUseText('')
        setTermsOfUseUrlPrefix('https://')
        setTermsOfUseUrl('')
        setTermsOfUseType('string')
        setIsPrivacyPolicy(false)
        setPrivacyPolicyText('')
        setPrivacyPolicyUrlPrefix('https://')
        setPrivacyPolicyUrl('')
        setPrivacyPolicyType('string')
      }

      if (customerUiService && customerUiService.config_params && customerUiService.config_params.logo) {
        setCustomerUiLogo(customerUiService.config_params.logo)
        setCustomerUiCurrentLogo(customerUiService.config_params.logo)
      } else {
        setCustomerUiLogo(null)
        setCustomerUiCurrentLogo(null)
      }
    }

    fetchFullData()
  }, [customerUiService, theme])
  
  useEffect(() => {
    const fetchCertificates = async () => {
      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientCertificateConfigs
      const request_data = { url, method: 'GET' }      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setCustomerUiCertificateJobs(response.data.filter(item => item.ui_type === 'client'))   
      } else {
        setCustomerUiCertificateJobs([])
      }
    }

    fetchCertificates()
  }, [])
  
  useEffect(() => {
    let domains_with_certificates = []

    customerUiDomain.forEach(d => {
      if (d.domain_name) {
        const domain_name = d.subdomain_prefix ? d.subdomain_prefix + '.' + d.domain_name : d.domain_name

        if (certificateAction === 'upload') {
          customerUiCertificates.forEach(c => {
            if (c.domain) {
              const is_wildcard_match = isWildcardMatch(c.domain, domain_name)
              if (is_wildcard_match) {
                domains_with_certificates.push(domain_name)
              }
            }
          })
        } else if (certificateAction === 'generate') {
          domains_with_certificates.push(domain_name)
        } else {
          const certificate_job = customerUiCertificateJobs.find(item => item.domain === domain_name)
        
          if (certificate_job) {
            if (certificate_job.cert_type === 'generate' || (certificate_job.status === 'ok' && getFormattedDateTime(certificate_job.expiration_date) > getFormattedDateTime())) {
              domains_with_certificates.push(domain_name)
            }
          }
        }        
      }
    })

    setDomainsWithCertificates(domains_with_certificates)
  }, [
    customerUiDomain,
    customerUiCertificateJobs,
    customerUiCertificates,
    certificateAction,
  ])
  
  return (
    <Box sx={wrapperStyle}>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={headStyle}
      >
        <Box sx={labelStyle}>
          <Box>{defaultTexts.openStackCustomerUi}</Box>
        </Box>
        <Box sx={{ paddingRight: '10px ' }}>
          {
            expanded ?
            <IconButton onClick={() => setExpanded(false)}>
              <FaMinimize color={theme.palette.greenSheen} />
            </IconButton> :
            <IconButton onClick={() => setExpanded(true)}>
              <FaMaximize color={theme.palette.greenSheen} />
            </IconButton>
          }
        </Box>
      </Stack>

      {
        expanded &&
        <Box sx={bodyStyle}>
          {
            editMode ?
            <CustomerUiEdit
              customerUiDomain={customerUiDomain}
              setCustomerUiDomain={setCustomerUiDomain}
              customerUiCertificates={customerUiCertificates}
              setCustomerUiCertificates={setCustomerUiCertificates}
              customerUiSiteKey={customerUiSiteKey}
              setCustomerUiSiteKey={setCustomerUiSiteKey}
              customerUiSecretKey={customerUiSecretKey}
              setCustomerUiSecretKey={setCustomerUiSecretKey}
              customerUiLogo={customerUiLogo}
              setCustomerUiLogo={setCustomerUiLogo}
              customerUiPrimaryColor={customerUiPrimaryColor}
              setCustomerUiPrimaryColor={setCustomerUiPrimaryColor}
              customerUiSecondaryColor={customerUiSecondaryColor}
              setCustomerUiSecondaryColor={setCustomerUiSecondaryColor}
              defaultOpenStackDomain={defaultOpenStackDomain}
              setDefaultOpenStackDomain={setDefaultOpenStackDomain}
              defaultOpenStackUserRole={defaultOpenStackUserRole}
              setDefaultOpenStackUserRole={setDefaultOpenStackUserRole}
              signUpEnabled={signUpEnabled}
              setSignUpEnabled={setSignUpEnabled}
              isUsername={isUsername}
              setIsUsername={setIsUsername}
              usernamePriority={usernamePriority}
              setUsernamePriority={setUsernamePriority}
              isPassword={isPassword}
              setIsPassword={setIsPassword}
              passwordPriority={passwordPriority}
              setPasswordPriority={setPasswordPriority}
              isConfirmPassword={isConfirmPassword}
              setIsConfirmPassword={setIsConfirmPassword}
              confirmPasswordPriority={confirmPasswordPriority}
              setConfirmPasswordPriority={setConfirmPasswordPriority}
              isEmail={isEmail}
              setIsEmail={setIsEmail}
              emailPriority={emailPriority}
              setEmailPriority={setEmailPriority}
              isTermsOfUse={isTermsOfUse}
              setIsTermsOfUse={setIsTermsOfUse}
              termsOfUseText={termsOfUseText}
              setTermsOfUseText={setTermsOfUseText}
              termsOfUseFile={termsOfUseFile}
              setTermsOfUseFile={setTermsOfUseFile}
              termsOfUseUrlPrefix={termsOfUseUrlPrefix}
              setTermsOfUseUrlPrefix={setTermsOfUseUrlPrefix}
              termsOfUseUrl={termsOfUseUrl}
              setTermsOfUseUrl={setTermsOfUseUrl}
              termsOfUseType={termsOfUseType}
              setTermsOfUseType={setTermsOfUseType}
              isPrivacyPolicy={isPrivacyPolicy}
              setIsPrivacyPolicy={setIsPrivacyPolicy}
              privacyPolicyText={privacyPolicyText}
              setPrivacyPolicyText={setPrivacyPolicyText}
              privacyPolicyFile={privacyPolicyFile}
              setPrivacyPolicyFile={setPrivacyPolicyFile}
              privacyPolicyUrlPrefix={privacyPolicyUrlPrefix}
              setPrivacyPolicyUrlPrefix={setPrivacyPolicyUrlPrefix}
              privacyPolicyUrl={privacyPolicyUrl}
              setPrivacyPolicyUrl={setPrivacyPolicyUrl}
              privacyPolicyType={privacyPolicyType}
              setPrivacyPolicyType={setPrivacyPolicyType}
              customFields={customFields}
              setCustomFields={setCustomFields}
              backgroundType={backgroundType}
              setBackgroundType={setBackgroundType}
              colorType={colorType}
              setColorType={setColorType}
              backgroundColor={backgroundColor}
              setBackgroundColor={setBackgroundColor}
              gradientColor1={gradientColor1}
              setGradientColor1={setGradientColor1}
              gradientColor2={gradientColor2}
              setGradientColor2={setGradientColor2}
              backgroundImage={backgroundImage}
              setBackgroundImage={setBackgroundImage}
              headingText={headingText}
              setHeadingText={setHeadingText}
              promoText1={promoText1}
              setPromoText1={setPromoText1}
              promoText2={promoText2}
              setPromoText2={setPromoText2}
              promoText3={promoText3}
              setPromoText3={setPromoText3}
              isContact={isContact}
              setIsContact={setIsContact}
              contactCompany={contactCompany}
              setContactCompany={setContactCompany}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              contactEmail={contactEmail}
              setContactEmail={setContactEmail}
              domainsWithCertififcates={domainsWithCertififcates}
              certificateAction={certificateAction}
              setCertificateAction={setCertificateAction}
              backgroundTypeList={getSelectFieldList('custom_client_ui', 'promo_config', 'background_type')}
              colorTypeList={getSelectFieldList('custom_client_ui', 'promo_config', 'background_color_type')}
              verifyDomain={verifyDomain}
              errors={errors}
              validateFormFields={validateFormFields}
            /> :
            <CustomerUiView
              { ...customerUiService }
              customerUiCertificateJobs={customerUiCertificateJobs}
            />
          }

          {
            editPermission &&
            <Stack
              direction='row'
              justifyContent='flex-end'
            >
              {
                editMode ?
                <Button
                  variant='contained'
                  disableRipple
                  disableElevation
                  disabled={false}
                  onClick={handleClickSave}
                  sx={saveButtonStyle}
                >
                  {defaultTexts.save}
                </Button> :
                <Button
                  variant='contained'
                  disableRipple
                  disableElevation
                  disabled={false}
                  onClick={handleClickEdit}
                  sx={editButtonStyle}
                >
                  {defaultTexts.edit}
                </Button>
              }            
            </Stack>
          }
        </Box>
      }

      <CustomDialog
        open={errorDialogOpen}
        onClose={handleErrorDialogClose}
        dialogTitle={{ title: defaultTexts.formValidationError }}
        dialogBody={{
          text: defaultTexts.formValidationErrorText,
          sx: { paddingBottom: '20px' }
        }}
      >
        {
          errors.map((item, index) => (
            <Box key={index}>{item.title}</Box>
          ))
        }
      </CustomDialog>
    </Box>
  )
}

export default CustomerUiWrapper